export default __webpack_public_path__ + "static/media/category_communicate_h.6af65ce0.svg";